import React, { useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import SettingsTable from '../../../../components/tables/SettingsTable';

const LoginIPs = () => {
  // Sample data generator
  const generateSampleData = (count = 60) => {
    const types = ['Admin', 'Distributor', 'Retailer', 'API User', 'Support'];
    const outletNames = [
      'Mumbai Branch', 'Delhi Office', 'Bangalore Center', 'Chennai Hub', 'Hyderabad Store',
      'Pune Outlet', 'Kolkata Branch', 'Ahmedabad Office', 'Jaipur Center', 'Lucknow Store'
    ];
    
    return Array.from({ length: count }, (_, i) => ({
      ip: `${103 + Math.floor(i / 50)}.${Math.floor((i * 7) % 256)}.${Math.floor((i * 13) % 256)}.${Math.floor((i * 3) % 256)}`,
      type: types[i % types.length],
      userId: `USER${String(i + 1).padStart(4, '0')}`,
      outletName: outletNames[i % outletNames.length],
      date: new Date(2024, 10, 4 - Math.floor(i / 5), 0, 0, 0).toISOString().split('T')[0],
      time: `${String(9 + (i % 12)).padStart(2, '0')}:${String((i * 5) % 60).padStart(2, '0')}:${String((i * 7) % 60).padStart(2, '0')}`
    }));
  };

  const [data] = useState(generateSampleData(60));

  // Column definitions
  const columns = [
    { key: 'ip', label: 'IP' },
    { key: 'type', label: 'Type' },
    { key: 'userId', label: 'User Id' },
    { key: 'outletName', label: 'Outlet Name' },
    { key: 'date', label: 'Date' },
    { key: 'time', label: 'Time' }
  ];

  return (
    <Container fluid className="">
      <SettingsTable
        data={data}
        settingsType="Login IP's"
        columns={columns}
      />
    </Container>
  );
};

export default LoginIPs;

